module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-900.512b1b3b464e844a4f1bb4dab0d02f29.woff";